import { useAxios } from 'shared/hooks/useAxios';
import { IShareableProfileResponse, IPublicProfileResponsePayload } from 'shared/interfaces/IPublicProfile';
import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { GET_SHAREABLE_PROFILE, GET_PUBLIC_PROFILE } from 'shared/queries/profile.queries';
const { POST } = useAxios();

export type PublicInfoProps = {
  countryCode: string;
  talentSlug: string;
  companySlug: string;
  divisionId: string;
  token?: string;
};

export const publicProfileDao = () => {
  const getPublicProfile = async (publicInfo: PublicInfoProps) => {
    const response = await POST<IPublicProfileResponsePayload>({
      url: `${ENDPOINTS.GRAPHQL}`,
      data: {
        query: GET_PUBLIC_PROFILE,
        variables: publicInfo,
      },
    });
    return response.data;
  };

  const getShareableProfile = async (id: string) => {
    const response = await POST<IShareableProfileResponse>({
      url: `${ENDPOINTS.GRAPHQL}`,
      data: {
        query: GET_SHAREABLE_PROFILE,
        variables: {
          id,
        },
      },
    });
    return response.data;
  };

  return {
    getShareableProfile,
    getPublicProfile,
  };
};
